module.exports = __webpack_public_path__ + "img/browser.e7d05e02.png";